// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/goal.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * ConversionGoal is the per-workspace registry row describing WHAT a
 * conversion means (reg/dep/rebill/sale/...), orthogonal to its status
 * (HOLD/APPROVED/REJECTED/REFUNDED). Goals drive ingest mapping, dedup mode
 * (allow_multiple), revenue rollups (counts_as_revenue), and the headline
 * conversions/CR metric (is_primary — max 1 per workspace).
 *
 * @generated from message tracker.v1.ConversionGoal
 */
export class ConversionGoal extends Message<ConversionGoal> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * Key is the stable slug persisted on every conversion event
   * (ClickHouse LowCardinality dictionary): ^[a-z][a-z0-9_]{0,31}$.
   *
   * @generated from field: string key = 3;
   */
  key = "";

  /**
   * @generated from field: string display_name = 4;
   */
  displayName = "";

  /**
   * Category buckets: registration|deposit|rebill|sale|lead|upsell|install|trial|custom.
   *
   * @generated from field: string category = 5;
   */
  category = "";

  /**
   * @generated from field: bool counts_as_revenue = 6;
   */
  countsAsRevenue = false;

  /**
   * @generated from field: bool is_primary = 7;
   */
  isPrimary = false;

  /**
   * @generated from field: bool allow_multiple = 8;
   */
  allowMultiple = false;

  /**
   * @generated from field: int32 sort_order = 9;
   */
  sortOrder = 0;

  /**
   * @generated from field: bool archived = 10;
   */
  archived = false;

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 12;
   */
  updatedAt = "";

  constructor(data?: PartialMessage<ConversionGoal>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ConversionGoal";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "counts_as_revenue", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_primary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "allow_multiple", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConversionGoal {
    return new ConversionGoal().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConversionGoal {
    return new ConversionGoal().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConversionGoal {
    return new ConversionGoal().fromJsonString(jsonString, options);
  }

  static equals(a: ConversionGoal | PlainMessage<ConversionGoal> | undefined, b: ConversionGoal | PlainMessage<ConversionGoal> | undefined): boolean {
    return proto3.util.equals(ConversionGoal, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListGoalsRequest
 */
export class ListGoalsRequest extends Message<ListGoalsRequest> {
  /**
   * @generated from field: bool include_archived = 1;
   */
  includeArchived = false;

  constructor(data?: PartialMessage<ListGoalsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListGoalsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "include_archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListGoalsRequest {
    return new ListGoalsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListGoalsRequest {
    return new ListGoalsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListGoalsRequest {
    return new ListGoalsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListGoalsRequest | PlainMessage<ListGoalsRequest> | undefined, b: ListGoalsRequest | PlainMessage<ListGoalsRequest> | undefined): boolean {
    return proto3.util.equals(ListGoalsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListGoalsResponse
 */
export class ListGoalsResponse extends Message<ListGoalsResponse> {
  /**
   * @generated from field: repeated tracker.v1.ConversionGoal items = 1;
   */
  items: ConversionGoal[] = [];

  constructor(data?: PartialMessage<ListGoalsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListGoalsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: ConversionGoal, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListGoalsResponse {
    return new ListGoalsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListGoalsResponse {
    return new ListGoalsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListGoalsResponse {
    return new ListGoalsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListGoalsResponse | PlainMessage<ListGoalsResponse> | undefined, b: ListGoalsResponse | PlainMessage<ListGoalsResponse> | undefined): boolean {
    return proto3.util.equals(ListGoalsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateGoalRequest
 */
export class CreateGoalRequest extends Message<CreateGoalRequest> {
  /**
   * @generated from field: tracker.v1.ConversionGoal goal = 1;
   */
  goal?: ConversionGoal;

  constructor(data?: PartialMessage<CreateGoalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateGoalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "goal", kind: "message", T: ConversionGoal },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateGoalRequest {
    return new CreateGoalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateGoalRequest {
    return new CreateGoalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateGoalRequest {
    return new CreateGoalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateGoalRequest | PlainMessage<CreateGoalRequest> | undefined, b: CreateGoalRequest | PlainMessage<CreateGoalRequest> | undefined): boolean {
    return proto3.util.equals(CreateGoalRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateGoalResponse
 */
export class CreateGoalResponse extends Message<CreateGoalResponse> {
  /**
   * @generated from field: tracker.v1.ConversionGoal goal = 1;
   */
  goal?: ConversionGoal;

  constructor(data?: PartialMessage<CreateGoalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateGoalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "goal", kind: "message", T: ConversionGoal },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateGoalResponse {
    return new CreateGoalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateGoalResponse {
    return new CreateGoalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateGoalResponse {
    return new CreateGoalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateGoalResponse | PlainMessage<CreateGoalResponse> | undefined, b: CreateGoalResponse | PlainMessage<CreateGoalResponse> | undefined): boolean {
    return proto3.util.equals(CreateGoalResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateGoalRequest
 */
export class UpdateGoalRequest extends Message<UpdateGoalRequest> {
  /**
   * @generated from field: tracker.v1.ConversionGoal goal = 1;
   */
  goal?: ConversionGoal;

  constructor(data?: PartialMessage<UpdateGoalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateGoalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "goal", kind: "message", T: ConversionGoal },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateGoalRequest {
    return new UpdateGoalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateGoalRequest {
    return new UpdateGoalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateGoalRequest {
    return new UpdateGoalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateGoalRequest | PlainMessage<UpdateGoalRequest> | undefined, b: UpdateGoalRequest | PlainMessage<UpdateGoalRequest> | undefined): boolean {
    return proto3.util.equals(UpdateGoalRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateGoalResponse
 */
export class UpdateGoalResponse extends Message<UpdateGoalResponse> {
  /**
   * @generated from field: tracker.v1.ConversionGoal goal = 1;
   */
  goal?: ConversionGoal;

  constructor(data?: PartialMessage<UpdateGoalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateGoalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "goal", kind: "message", T: ConversionGoal },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateGoalResponse {
    return new UpdateGoalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateGoalResponse {
    return new UpdateGoalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateGoalResponse {
    return new UpdateGoalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateGoalResponse | PlainMessage<UpdateGoalResponse> | undefined, b: UpdateGoalResponse | PlainMessage<UpdateGoalResponse> | undefined): boolean {
    return proto3.util.equals(UpdateGoalResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteGoalRequest
 */
export class DeleteGoalRequest extends Message<DeleteGoalRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteGoalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteGoalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteGoalRequest {
    return new DeleteGoalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteGoalRequest {
    return new DeleteGoalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteGoalRequest {
    return new DeleteGoalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteGoalRequest | PlainMessage<DeleteGoalRequest> | undefined, b: DeleteGoalRequest | PlainMessage<DeleteGoalRequest> | undefined): boolean {
    return proto3.util.equals(DeleteGoalRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteGoalResponse
 */
export class DeleteGoalResponse extends Message<DeleteGoalResponse> {
  constructor(data?: PartialMessage<DeleteGoalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteGoalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteGoalResponse {
    return new DeleteGoalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteGoalResponse {
    return new DeleteGoalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteGoalResponse {
    return new DeleteGoalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteGoalResponse | PlainMessage<DeleteGoalResponse> | undefined, b: DeleteGoalResponse | PlainMessage<DeleteGoalResponse> | undefined): boolean {
    return proto3.util.equals(DeleteGoalResponse, a, b);
  }
}

/**
 * GoalPresetDefinition mirrors the code-owned internal/preset catalog: the
 * goal set + defaults a preset seeds. Read-only — presets are code, not data.
 *
 * @generated from message tracker.v1.GoalPresetDefinition
 */
export class GoalPresetDefinition extends Message<GoalPresetDefinition> {
  /**
   * preset key: generic | nutra | gambling | ...
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string display_name = 2;
   */
  displayName = "";

  /**
   * template rows: id/workspace_id/timestamps empty
   *
   * @generated from field: repeated tracker.v1.ConversionGoal goals = 3;
   */
  goals: ConversionGoal[] = [];

  constructor(data?: PartialMessage<GoalPresetDefinition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GoalPresetDefinition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goals", kind: "message", T: ConversionGoal, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GoalPresetDefinition {
    return new GoalPresetDefinition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GoalPresetDefinition {
    return new GoalPresetDefinition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GoalPresetDefinition {
    return new GoalPresetDefinition().fromJsonString(jsonString, options);
  }

  static equals(a: GoalPresetDefinition | PlainMessage<GoalPresetDefinition> | undefined, b: GoalPresetDefinition | PlainMessage<GoalPresetDefinition> | undefined): boolean {
    return proto3.util.equals(GoalPresetDefinition, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListPresetsRequest
 */
export class ListPresetsRequest extends Message<ListPresetsRequest> {
  constructor(data?: PartialMessage<ListPresetsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListPresetsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPresetsRequest {
    return new ListPresetsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPresetsRequest {
    return new ListPresetsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPresetsRequest {
    return new ListPresetsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPresetsRequest | PlainMessage<ListPresetsRequest> | undefined, b: ListPresetsRequest | PlainMessage<ListPresetsRequest> | undefined): boolean {
    return proto3.util.equals(ListPresetsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListPresetsResponse
 */
export class ListPresetsResponse extends Message<ListPresetsResponse> {
  /**
   * @generated from field: repeated tracker.v1.GoalPresetDefinition presets = 1;
   */
  presets: GoalPresetDefinition[] = [];

  constructor(data?: PartialMessage<ListPresetsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListPresetsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "presets", kind: "message", T: GoalPresetDefinition, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPresetsResponse {
    return new ListPresetsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPresetsResponse {
    return new ListPresetsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPresetsResponse {
    return new ListPresetsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPresetsResponse | PlainMessage<ListPresetsResponse> | undefined, b: ListPresetsResponse | PlainMessage<ListPresetsResponse> | undefined): boolean {
    return proto3.util.equals(ListPresetsResponse, a, b);
  }
}

/**
 * SeedPresetGoals inserts the preset's goals into the workspace registry
 * (existing keys untouched; the 'conversion' fallback primary is demoted in
 * favor of the preset's primary).
 *
 * @generated from message tracker.v1.SeedPresetGoalsRequest
 */
export class SeedPresetGoalsRequest extends Message<SeedPresetGoalsRequest> {
  /**
   * @generated from field: string preset = 1;
   */
  preset = "";

  constructor(data?: PartialMessage<SeedPresetGoalsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SeedPresetGoalsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "preset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SeedPresetGoalsRequest {
    return new SeedPresetGoalsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SeedPresetGoalsRequest {
    return new SeedPresetGoalsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SeedPresetGoalsRequest {
    return new SeedPresetGoalsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SeedPresetGoalsRequest | PlainMessage<SeedPresetGoalsRequest> | undefined, b: SeedPresetGoalsRequest | PlainMessage<SeedPresetGoalsRequest> | undefined): boolean {
    return proto3.util.equals(SeedPresetGoalsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SeedPresetGoalsResponse
 */
export class SeedPresetGoalsResponse extends Message<SeedPresetGoalsResponse> {
  /**
   * @generated from field: repeated tracker.v1.ConversionGoal items = 1;
   */
  items: ConversionGoal[] = [];

  constructor(data?: PartialMessage<SeedPresetGoalsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SeedPresetGoalsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: ConversionGoal, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SeedPresetGoalsResponse {
    return new SeedPresetGoalsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SeedPresetGoalsResponse {
    return new SeedPresetGoalsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SeedPresetGoalsResponse {
    return new SeedPresetGoalsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SeedPresetGoalsResponse | PlainMessage<SeedPresetGoalsResponse> | undefined, b: SeedPresetGoalsResponse | PlainMessage<SeedPresetGoalsResponse> | undefined): boolean {
    return proto3.util.equals(SeedPresetGoalsResponse, a, b);
  }
}

